/**
 * @generated SignedSource<<d533e0255ed430eacd8cbe4ef20af71b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type AllSkillsFilterInput = {
  isActive?: boolean | null | undefined;
  skillCode?: string | null | undefined;
  skillName?: string | null | undefined;
  skillType?: string | null | undefined;
  standardGradeIds?: ReadonlyArray<string> | null | undefined;
  targetGroupIds?: ReadonlyArray<string> | null | undefined;
  targetIds?: ReadonlyArray<string> | null | undefined;
};
export type SkillsProgressTableQuery$variables = {
  after?: string | null | undefined;
  before?: string | null | undefined;
  filter: AllSkillsFilterInput;
  first?: number | null | undefined;
  last?: number | null | undefined;
  skip?: boolean | null | undefined;
  targetGroupsIds?: ReadonlyArray<string> | null | undefined;
};
export type SkillsProgressTableQuery$data = {
  readonly allSkills?: {
    readonly edges: ReadonlyArray<{
      readonly cursor: string;
    }> | null | undefined;
    readonly nodes: ReadonlyArray<{
      readonly code: string | null | undefined;
      readonly id: string;
      readonly name: string | null | undefined;
      readonly targetSkills: ReadonlyArray<{
        readonly id: string;
        readonly target: {
          readonly id: string;
          readonly name: string | null | undefined;
          readonly targetGroup: {
            readonly id: string;
            readonly name: string | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly targetSkillType: {
          readonly id: string;
          readonly name: string | null | undefined;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    }> | null | undefined;
    readonly pageInfo: {
      readonly endCursor: string | null | undefined;
      readonly hasNextPage: boolean;
      readonly hasPreviousPage: boolean;
      readonly startCursor: string | null | undefined;
    };
    readonly totalCount: number;
  } | null | undefined;
};
export type SkillsProgressTableQuery = {
  response: SkillsProgressTableQuery$data;
  variables: SkillsProgressTableQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "before"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filter"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "last"
},
v5 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "skip"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "targetGroupsIds"
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v9 = [
  (v7/*: any*/),
  (v8/*: any*/)
],
v10 = [
  {
    "condition": "skip",
    "kind": "Condition",
    "passingValue": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
          },
          {
            "kind": "Variable",
            "name": "before",
            "variableName": "before"
          },
          {
            "kind": "Variable",
            "name": "filter",
            "variableName": "filter"
          },
          {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
          },
          {
            "kind": "Variable",
            "name": "last",
            "variableName": "last"
          }
        ],
        "concreteType": "SkillNodeConnection",
        "kind": "LinkedField",
        "name": "allSkills",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SkillNode",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v7/*: any*/),
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "code",
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "fields": [
                      {
                        "kind": "Literal",
                        "name": "isActive",
                        "value": "ACTIVE"
                      },
                      {
                        "kind": "Variable",
                        "name": "targetGroupIds",
                        "variableName": "targetGroupsIds"
                      }
                    ],
                    "kind": "ObjectValue",
                    "name": "filter"
                  }
                ],
                "concreteType": "TargetSkillNode",
                "kind": "LinkedField",
                "name": "targetSkills",
                "plural": true,
                "selections": [
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TargetNode",
                    "kind": "LinkedField",
                    "name": "target",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      (v8/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TargetGroupNode",
                        "kind": "LinkedField",
                        "name": "targetGroup",
                        "plural": false,
                        "selections": (v9/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TargetSkillTypeNode",
                    "kind": "LinkedField",
                    "name": "targetSkillType",
                    "plural": false,
                    "selections": (v9/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SkillNodeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "SkillsProgressTableQuery",
    "selections": (v10/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v5/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/),
      (v4/*: any*/),
      (v1/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Operation",
    "name": "SkillsProgressTableQuery",
    "selections": (v10/*: any*/)
  },
  "params": {
    "cacheID": "e9f74b2156bbd41b00d55c78ddec8898",
    "id": null,
    "metadata": {},
    "name": "SkillsProgressTableQuery",
    "operationKind": "query",
    "text": "query SkillsProgressTableQuery(\n  $filter: AllSkillsFilterInput!\n  $skip: Boolean = false\n  $first: Int\n  $after: String\n  $last: Int\n  $before: String\n  $targetGroupsIds: [ID!]\n) {\n  allSkills(filter: $filter, first: $first, after: $after, last: $last, before: $before) @skip(if: $skip) {\n    nodes {\n      id\n      name\n      code\n      targetSkills(filter: {targetGroupIds: $targetGroupsIds, isActive: ACTIVE}) {\n        id\n        target {\n          id\n          name\n          targetGroup {\n            id\n            name\n          }\n        }\n        targetSkillType {\n          id\n          name\n        }\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n      hasPreviousPage\n      startCursor\n    }\n    edges {\n      cursor\n    }\n    totalCount\n  }\n}\n"
  }
};
})();

(node as any).hash = "b31a6fcbfecf759a88916363f31ea766";

export default node;
